const STORE_DOMAIN = "41dd61-2.myshopify.com";
const STOREFRONT_TOKEN = "6821e8995933dbe297487c7021bbb00a";

$(document).on('change', '.mrk-file-upload', async function () {
  var fileInput  = this;
  const file = fileInput.files[0];
  // ✅ Check image resolution (max 25MP)
  const imgUrl = URL.createObjectURL(file);
  const img = new Image();
  const imageLoaded = new Promise((resolve, reject) => {
    img.onload = () => {
      const megapixels = (img.width * img.height) / 1000000;
      if (megapixels > 25) {
        alert(`FIle troppo grande: ${megapixels.toFixed(2)} (limite 25MP), carica un immagine più piccola`);
        fileInput.value = ''; // reset input
        resolve(false);
      } else {
        resolve(true);
      }
    };
    img.onerror = reject;
  });

  img.src = imgUrl;
  const isValid = await imageLoaded;
  URL.revokeObjectURL(imgUrl); // clean up

  if (!isValid) return null;

  
  $(this).parents('.mrk-file-item').find('.mrk-image-preview').html(`<span class="mrk-loader"></span>`);
  const imageUrl = await uploadImage(this);
  if (imageUrl) {
    $(this).closest('.mrk-file-upload').siblings('.mrk-hidden-file').val(imageUrl);

    var position = $(this).attr('position');
    $(`.mrk-position-image[position="${position}"]`).attr('src', imageUrl).show();
    $(this).parents('.mrk-file-item').find('.mrk-image-preview').html(`<img src="${imageUrl}"/>`);
    $('.mrk-table-column-item .quantity__input').trigger('change')
  }
});
$(document).ready(function () {
  $('.mrk-print-type input').on('change', function () {
    const selectedValue = $(this).val();
    $('.mrk-dropdowns').hide();
    $(`.mrk-dropdowns[data="${selectedValue}"]`).show();
    $('.mrk-dropdown-item input').prop('checked', false);
    $('.mrk-file-item-wrapper').hide();
    $('.mrk-table-column-item .quantity__input').trigger('change')
  });

  $(document).on('change', '.mrk-dropdown-item input', function () {
    $('.mrk-file-item-wrapper').hide();
    $('.mrk-dropdown-item input:checked').each(function(){
      const selectedFile = $(this).val();
      $(`.mrk-file-item-wrapper[file="${selectedFile}"]`).show();
    })
    $('.mrk-table-column-item .quantity__input').trigger('change')
  });

  $('.mrk-print-type input:checked').trigger('change');

  // Quantita': NON disabilitare mai il campo visibile (altrimenti dopo l'azzeramento
  // non e' piu' cliccabile). Disabilito solo l'id nascosto.
  $(document).on('change input', '.mrk-table-column-quantity-picker .quantity__input', function () {
    const $input = $(this);
    const quantity = parseInt($input.val()) || 0;
    const price = parseInt($input.attr('price')) || 0;

    const $item = $input.closest('.mrk-table-column-item');
    const $hiddenId = $item.find('.mrk-hidden-id');
    const $moneyContainer = $item.find('.mrk-variant-price .money');

    $item.toggleClass('mrk-has-qty', quantity > 0);

    if ($hiddenId.length) {
      if (quantity > 0) {
        $hiddenId.removeAttr('disabled');
      } else {
        $hiddenId.attr('disabled', true);
      }
    }

    if ($moneyContainer.length) {
      const total = quantity * price;
      $moneyContainer.html(formatMoney(total, "€{{ amount_with_comma_separator }}"));
    }

    updateTotalPrice();
    updateHiddenInputs();
    $('[name="id"]').attr('disabled', true);

    var anyQty = false;
    $('.mrk-multi-variants-table-wrapper .quantity__input').each(function () {
      if ((parseInt($(this).val(), 10) || 0) > 0) anyQty = true;
    });
    var btn = document.getElementById('mrk-bulk-atc');
    if (btn) btn.disabled = !anyQty;
  });
});

async function uploadImage(fileInput) {
  const file = fileInput.files[0];
  if (!file) return null;
  
  const formData = new FormData();
  formData.append('file', file);
  formData.append('form_instance_id', '521989');
  formData.append('shopify_domain', STORE_DOMAIN);

  try {
    const response = await fetch('https://forms.shopifyapps.com/api/v2/file_upload', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }

    const uploadResult = await response.json();
    await new Promise(resolve => setTimeout(resolve, 2000));

    const query = `
      query {
        node(id: "${uploadResult.file_reference}") {
          ... on MediaImage {
            image { url altText }
          }
        }
      }
    `;

    let imgUrl = null;
    for (let attempt = 1; attempt <= 8; attempt++) {
      const gqlRes = await fetch(`https://${STORE_DOMAIN}/api/2025-04/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query }),
      });
      const gqlData = await gqlRes.json();
      imgUrl = gqlData?.data?.node?.image?.url;
      if (imgUrl) break;
      await new Promise(resolve => setTimeout(resolve, 2000));
    }
    return imgUrl || null;
  } catch (err) {
    console.error("Error:", err);
    return null;
  }
}

function updateTotalPrice() {
  let total = 0;
  $('.mrk-multi-variants-table-wrapper .quantity__input').each(function () {
    const qty = parseInt($(this).val()) || 0;
    const price = parseInt($(this).attr('price')) || 0;
    total += qty * price;
  });
  const $totalPriceContainer = $('.mrk-total-price');
  if ($totalPriceContainer.length) {
    $totalPriceContainer.html(formatMoney(total, "€{{ amount_with_comma_separator }}"));
  }
}
function updateHiddenInputs() {
  let html = '';
  let tatalQuantity = 0;
  $('.mrk-multi-variants-table-wrapper .quantity__input').each(function () {
    $('.mrk-hidden-inputs').html("");
    const $input = $(this);
    const quantity = parseInt($input.val()) || 0;
    if (quantity <= 0) return;
    tatalQuantity = tatalQuantity + quantity;
    const dataName = $input.attr('data-name');

    const $printType = $('.mrk-print-type input:checked');
    const printTypeValue = $printType.val() || '';
    const printTypeName = $printType.attr('name') || '';
    if (printTypeName && printTypeValue) {
      html += `<input type="hidden" name="${dataName}[properties[${printTypeName}]]" value="${printTypeValue}">`;
    }

    const checkedDropdowns = $('.mrk-dropdown-item input:checked');
    let combinedValue = [];
    checkedDropdowns.each(function () { combinedValue.push($(this).val()); });
    if (combinedValue.length > 0) {
      const keyStr = buildGroupKeyString();
      hashGroupKey(keyStr).then((groupKey) => {
      html += `<input type="hidden" name="${dataName}[properties[Positions]]" value="${combinedValue.join(', ')}">`;
      html += `<input type="hidden" name="${dataName}[properties[group_key]]" value="${groupKey}">`;
      })
    }
    checkedDropdowns.each(function () {
      const value = $(this).val();
      const fileInput = $(`[name="${value}"]`);
      if (fileInput.length > 0 && fileInput.val()) {
        html += `<input type="hidden" name="${dataName}[properties[${value} Image]]" value="${fileInput.val()}">`;
      }
    });
  }); 
  const engravingVariant = additionalProduct();
  if(engravingVariant){
    html += `<input type="hidden" name="items[100][id]" value="${engravingVariant.id}"><input type="hidden" name="items[100][quantity]" value="${tatalQuantity}">`
    const keyStr = buildGroupKeyString();
    hashGroupKey(keyStr).then((groupKey) => {
        html += `<input type="hidden" name="items[100][properties[group_key]]" value="${groupKey}">`
        html += `<input type="hidden" name="items[100][properties[is_customization]]" value="true">`
        $('.mrk-hidden-inputs').html(html);
    });
  }
}
function additionalProduct(){
  let totalPrice = 0;
  $('[name="position"]:checked').each(function () {
    const priceAttr = parseInt($(this).attr('price'), 10);
    if (!isNaN(priceAttr)) { totalPrice += priceAttr; }
  });
  if (!window.mrkVariants) return;
  const matchingVariant = window.mrkVariants.find(v => v.price === totalPrice);
  if (matchingVariant) { return matchingVariant; }
}

function buildGroupKeyString() {
  const type = ($('.mrk-print-type input:checked').val() || '').trim();
  const positions = $('.mrk-dropdown-item input:checked')
    .map((_, el) => $(el).val().trim()).get().filter(Boolean).sort().join('|');
  const imgs = $('.mrk-dropdown-item input:checked')
    .map((_, el) => { const name = $(el).val(); return $(`[name="${name}"]`).val() || ''; })
    .get().filter(Boolean).sort().join('|');
  return `type=${type}::pos=${positions}::img=${imgs}`;
}

async function hashGroupKey(str) {
  if (window.crypto?.subtle) {
    const enc = new TextEncoder().encode(str);
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return Array.from(new Uint8Array(buf).slice(0, 10))
      .map(b => b.toString(16).padStart(2, '0')).join('');
  }
  return 'gk_' + btoa(unescape(encodeURIComponent(str))).replace(/=+$/,'');
}
